<div class="image-container">
  <img [src]="imageUrl || '/assets/images/profile/user.jpg'" />
  <div [id]="'AT_imgProfileCamera'" class="cameraIconContainer" *ngIf="uploaderEnabled" (click)="openModal()">
    <a>
      <mat-icon>photo_camera</mat-icon>
    </a>
  </div>
</div>
